import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 font-mono-label text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
